import LinkWrapper from "../link-wrapper/link-wrapper";
import styles from "./shortcut.module.less";

export type TShortcutProps = {
  title: string;
  icon?: string;
  url: string;
};

export const Shortcut = ({ title, icon, url }: TShortcutProps) => {
  const withPresetIcon = icon && typeof icon === "string";

  return (
    <LinkWrapper url={url} className={styles.linkWrapper}>
      <div className={[styles.wrapper, withPresetIcon ? styles.withPresetIcon : ""].join(" ")}>
        {icon && (
          <div className={styles.icon}>
            <span className={icon} />
          </div>
        )}
        <div className={styles.titleIconWrapper}>
          <div className={[styles.title, "body-base mb-0"].join(" ")}>{title}</div>
          {!icon && <span className={[icon, "ui-icon-arrow-right"].join(" ")} />}
        </div>
      </div>
    </LinkWrapper>
  );
};
